import styled from 'styled-components';

export const AgencyGroupSelectorstyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;

  div {
    flex: 1;
  }
`;
